// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__31CXw","content":"Consent_content__2yYFY","footer":"Consent_footer__2BBBV"};